import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PublicLayout from "@/components/PublicLayout";
import { api } from "@/lib/api";
import { useLocale } from "@/contexts/LocaleContext";

export default function LegalPage({ slug, fallbackTitle, testid }) {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const [page, setPage] = useState(null);

  useEffect(() => {
    api.get(`/public/pages/${slug}`).then((r) => setPage(r.data)).catch(() => {});
  }, [slug]);

  const data = page?.sections?.[locale] || page?.sections?.hr || {};

  return (
    <PublicLayout
      pageTitle={data.title || fallbackTitle}
      pageDescription={(data.body_html || "").replace(/<[^>]+>/g, "").slice(0, 160)}
      testid={testid || `legal-${slug}`}
    >
      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <p className="text-xs uppercase tracking-[0.3em] text-primary/80">— Legal</p>
        <h1
          className="font-display text-4xl sm:text-5xl mt-3"
          data-testid={`legal-${slug}-title`}
        >
          {data.title || fallbackTitle}
        </h1>
        <div
          className="prose prose-invert prose-headings:font-display max-w-none mt-10 text-base sm:text-lg leading-relaxed [&_p]:mb-5 [&_a]:text-primary [&_h2]:mt-8 [&_h2]:mb-3 [&_strong]:text-foreground"
          data-testid={`legal-${slug}-body`}
          dangerouslySetInnerHTML={{ __html: data.body_html || "" }}
        />
      </section>
    </PublicLayout>
  );
}
